import { v4 as uuidv4 } from 'uuid';
export function generate() {
    return uuidv4();
}
export function iutkMiddleware(domain) {
    return function (req, res, next) {
        if (!req.cookies.iutk) {
            var iutk = generate();
            res.locals.iutk = iutk;
            res.cookie('iutk', iutk, {
                domain: domain,
                httpOnly: false,
                maxAge: 60 * 60 * 24 * 30 * 6,
                path: '/'
            });
        }
        else {
            res.locals.iutk = req.cookies.iutk;
        }
        next();
    };
}
//# sourceMappingURL=index.js.map